// Remove custom style var and sx prop
import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import LoadingButtonWrapper from '~/components/LoadingButtonWrapper';

type PromoteInProgressModalPropOptions = {
  open: boolean;
};

const PromoteInProgressModal = ({
  open,
}: PromoteInProgressModalPropOptions) => {
  const { t } = useTranslation('cloud', {
    keyPrefix: 'staging.promoteSite.promoteModal',
  });

  return (
    <Dialog
      open={open}
      keepMounted
      aria-label={'promote site in progress'}
      data-testid={'promote-site-in-progress-modal'}
      maxWidth={'sm'}
      fullWidth
    >
      <DialogTitle>
        {t('title')}
        <Divider sx={{ mt: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" noWrap>
          {t('promotionInProgress')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButtonWrapper
          data-testid={'promote-in-progress-button'}
          variant="contained"
          loading={true}
        >
          {t('goLiveBtn')}
        </LoadingButtonWrapper>
      </DialogActions>
    </Dialog>
  );
};
export default PromoteInProgressModal;
